import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './weeklyCsvExportDialog.component.html';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  template: templateString
})
export class WeeklyCsvExportDialogComponent implements OnInit {
	@Output() action = new EventEmitter();

	public startDate;
	public endDate;
	public displayDateStart;
	public displayDateEnd;
	public datePickerConfig;
	public candidateTypes;
	public candidateTypeIds: {} = {};
	public checkAllCandidateTypeIds = true;

	constructor(
		private renderer: Renderer2,
		private bsModalRef: BsModalRef
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

	export() {
		var self = this;

		this.action.emit({
			startDate: this.startDate.clone().format('YYYY-MM-DD'),
			endDate: this.endDate.clone().format('YYYY-MM-DD'),
			candidateTypeIds: this.candidateTypes.map(function(candidateType) {
				return self.candidateTypeIds[candidateType.id] ? candidateType.id : null;
			}).filter(function(candidateTypeId) { return candidateTypeId; })
		});
		this.bsModalRef.hide();
	}

	checkUncheckAllCandidateTypeIds() {
		var self = this;
		this.candidateTypes.forEach(function(candidateType) {
			self.candidateTypeIds[candidateType.id] = self.checkAllCandidateTypeIds;
		});
	}

	cancel() {
		this.bsModalRef.hide();
	}

	ngOnInit(): void {
		this.datePickerConfig = {
			firstDayOfWeek: "mo"
		};

		this.startDate = this.startDate ? moment(this.startDate) : moment().startOf('isoWeek');
		this.endDate = this.endDate ? moment(this.endDate) : moment().endOf('isoWeek');
		this.displayDateStart = this.startDate;
		this.displayDateEnd = this.endDate;

		this.candidateTypes = this.candidateTypes || [];
		this.candidateTypes.forEach(candidateType => {
			this.candidateTypeIds[candidateType.id] = true;
		});
	}
}
